module.exports = __webpack_public_path__ + "img/3.abcdcc65.png";